// PLAY
document.addEventListener("DOMContentLoaded", function () {
	const videosInsta = document.querySelectorAll(".mm-id-video");

	videosInsta.forEach((videoContainer, index) => {
		const section = videoContainer.closest("section");

		const video = videoContainer.querySelector("video");
		video.removeAttribute("controls");

		const toggleBtns = videoContainer.parentElement.querySelectorAll(".mm-video-toggle");
		const playBtn = videoContainer.parentElement.querySelector(".mm-video-play");

		// Ciblage des boutons mobiles dans la section mobile
		const playBtnMobile = document.querySelectorAll(".play-btn-mobile")[index];
		const pauseBtnMobile = document.querySelectorAll(".pause-btn-mobile")[index];

		const productBlock = videoContainer.parentElement.querySelector(".mm-video-product-block");
		const bottomBtnContainer = videoContainer.querySelector(".mm-info-bottom-vala");

		/* progress bar */
		const progressBarContainer = videoContainer.querySelector(".mm-video-timer-container");
		const progressBar = progressBarContainer.querySelector(".mm-video-progress-bar");
		const currentTimeEl = progressBarContainer.querySelector(".mm-video-time-current");
		const totalTimeEl = progressBarContainer.querySelector(".mm-video-time-total");

		/* Mobile */
		const totalTimeMobile = section.querySelectorAll(".mm-wrapper-timer-total-mobile span")[index];

		// Met à jour la durée totale au chargement des métadonnées
		video.addEventListener("loadedmetadata", () => {
			video.removeAttribute("controls");
			const totalMinutes = Math.floor(video.duration / 60);
			const totalSeconds = Math.floor(video.duration % 60)
				.toString()
				.padStart(2, "0");
			totalTimeEl.textContent = `${totalMinutes}:${totalSeconds}`;
			/* Mobile */
			if (window.innerWidth <= 768) {
				if (totalTimeMobile) {
					totalTimeMobile.textContent = `${totalMinutes}:${totalSeconds}`;
				}
			}
		});

		video.addEventListener("timeupdate", () => {
			const currentMinutes = Math.floor(video.currentTime / 60);
			const currentSeconds = Math.floor(video.currentTime % 60)
				.toString()
				.padStart(2, "0");
			currentTimeEl.textContent = `${currentMinutes}:${currentSeconds}`;
			const percentage = (video.currentTime / video.duration) * 100;
			progressBar.style.width = `${percentage}%`;
		});

		// Bouton Play Desktop
		toggleBtns.forEach((btn) => {
			btn.addEventListener("click", () => {
				if (video.paused) {
					video.play();
				} else {
					video.pause();
				}
			});
		});

		// Bouton Play Mobile
		if (playBtnMobile) {
			playBtnMobile.addEventListener("click", () => {
				video.play();
			});
		}

		// Bouton Pause Mobile
		if (pauseBtnMobile) {
			pauseBtnMobile.addEventListener("click", () => {
				video.pause();
			});
		}

		// Lors de la pause de la vidéo
		video.addEventListener("pause", () => {
			video.controls = false;
			playBtn.style.opacity = "1";
			if (playBtnMobile) {
				playBtnMobile.classList.remove("hidden");
				pauseBtnMobile.classList.add("hidden");
			}
			bottomBtnContainer.classList.add("hidden");

			video.removeAttribute("controls");
			productBlock.classList.remove("active"); // Cache le bloc
		});

		// Lors de la lecture de la vidéo
		video.addEventListener("play", () => {
			video.controls = false;
			playBtn.style.opacity = "0";
			if (playBtnMobile) {
				playBtnMobile.classList.add("hidden");
				pauseBtnMobile.classList.remove("hidden");
			}
			bottomBtnContainer.classList.remove("hidden");

			productBlock.classList.add("active"); // Affiche le bloc
		});

		/* Toggle sound */
		const ctaSoundContainer = videoContainer.querySelector("#mm-volume-btn");
		if (ctaSoundContainer) {
			const videoSound = ctaSoundContainer.querySelector(".mm-sound");
			const videoMuted = ctaSoundContainer.querySelector(".mm-muted");
			videoSound.addEventListener("click", (event) => {
				video.muted = true;
				videoSound.classList.add("hidden");
				videoMuted.classList.remove("hidden");
			});
			videoMuted.addEventListener("click", (event) => {
				video.muted = false;
				videoSound.classList.remove("hidden");
				videoMuted.classList.add("hidden");
			});
		}

		// Crée un IntersectionObserver
		const observer = new IntersectionObserver(
			(entries) => {
				entries.forEach((entry) => {
					const videoContainer = entry.target;
					const video = videoContainer.querySelector("video");

					if (entry.isIntersecting) {
						if (window.innerWidth <= 768) {
							video.style.opacity = "1"; // Réduire l'opacité
						}
					} else {
						// Si la vidéo sort de la vue, la mettre en pause
						video.pause();
						if (window.innerWidth <= 768) {
							video.style.opacity = "0.4"; // Réduire l'opacité
						}
					}
				});
			},
			{
				threshold: 0.5, // La vidéo doit être au moins visible à 50% pour être considérée comme "dans le viewport"
			}
		);

		observer.observe(videoContainer);
	});
});
